
import {getProductByID, toBlind } from '../shop-front-component/ProductCollection'

import GenericProductPage from './GenericProductPage'

export default function ZebraBlindsPage() {

  return (
      GenericProductPage(getProductByID(42),toBlind)
  )
}
